module.exports = __webpack_public_path__ + "img/main_bg_1.ff052fd.webp";